import { wireCopyButton } from "./copy-button.js";
import { plainFlavours } from "./copy-html.js";
import { slot } from "./dom.js";
import { urlFor, type WritableState } from "./url-state.js";

/**
 * The Copy link button.
 *
 * The address bar already tracks the tool, so a bookmark works without this.
 * The button is for the other half — sending somebody a converted sentence —
 * which is worth being able to do without knowing that the URL was keeping up.
 *
 * Every tool wants it and they all want the same thing from it, so the
 * wiring lives here and each of them passes what its own link should say.
 */
export function wireShareLink(
  container: HTMLElement,
  state: () => WritableState,
): void {
  const button = slot(container, "copy-link");

  if (!(button instanceof HTMLButtonElement)) {
    return;
  }

  // Plain text, not the coloured flavour the pinyin uses: a URL pasted
  // anywhere should arrive as a URL, and a word processor makes it a link on
  // its own.
  wireCopyButton(button, () => plainFlavours(urlFor(location.href, state())));
}
